import React from "react";
import { ReactComponent as DownloadIcon } from "../../../assets/svg/downloadIcon.svg";
import HyperLink from "../hyper-link/hyper-link";

export type DownloadButtonType = "Round" | "Link" | "Button" | "Icon";

interface IDownloadButton {
	onClick: () => void;
	type: DownloadButtonType;
	text?: string; // Optional text for Button or Link types
}

const DownloadButton: React.FC<IDownloadButton> = ({
	onClick,
	type,
	text = "Download",
}) => {
	// Styling based on the button type
	let buttonClasses = "";
	const iconClasses = "w-4 h-4 text-white";

	switch (type) {
		case "Round":
			buttonClasses =
				"bg-gradient-to-r from-sky-700 to-sky-950 text-white p-2 rounded-full flex items-center justify-center";
			break;
		case "Link":
			buttonClasses =
				"text-sky-600 underline font-semibold flex items-center gap-2";
			break;
		case "Button":
			buttonClasses =
				"bg-gradient-to-r from-sky-700 to-sky-950 text-white px-4 py-2 rounded-full flex items-center gap-2";
			break;
		case "Icon":
			buttonClasses =
				"text-black text-lg rounded-full flex items-center gap-2";
			break;
		default:
			console.error("Invalid button type. Defaulting to Button.");
			buttonClasses =
				"bg-gradient-to-r from-sky-700 to-sky-950 text-white px-4 py-2 rounded-full flex items-center gap-2";
			break;
	}

	return (
		<>
			{type === "Link" ? (
				<HyperLink
					onClick={() => onClick()}
					href={"#"}
					label={text}
					aria-label={text} // Accessibility
				/>
			) : (
				<button
					className={`font-Poppins font-semibold text-sm ${buttonClasses}`}
					onClick={onClick}
					aria-label={text} // Accessibility
				>
					<DownloadIcon className={iconClasses} />
					{type !== "Round" && type != "Icon" && <span>{text}</span>}
				</button>
			)}
		</>
	);
};

export default DownloadButton;
